<template>
    <div class="chat-drawer-container toggle-screen-wrapper">
        <div id="chatroom-screen" :class="(showDrawer) ? 'chatroom-active' : null">
            <div class="Chatroom-screen-side-wrapper">
                <component :is="activeComponent" 
                    :activeTab="activeTab" 
                    :chatRoomID="chatRoom.chat_room_id"
                    :roomMembers="roomMembers"
                    :chatHistoryMembers="chatRoomChatHistory"
                    :senderUser="userProfile"
                    :recepientUser="selectedMemberForChat"
                    :unreadMessageCount="unreadMessageCount"
                    @handleBackClick="handleBackClick"
                    @handleChatSelection="handleChatSelection"
                    @switchTabView="switchTabView"
                    @switchComponent="switchComponent"
                    @toggleUserProfile="toggleUserProfile"
                    @closeDrawer="$emit('closeDrawer')"
                    @handleProfileUpdate="handleProfileUpdate"
                />    
            </div>
        </div>
        <UserProfileDrawer 
            :isOpen="showUserProfile" 
            :userProfile="selectedProfileToView" 
            @selectForChat="selectForChat"
            @closeDrawer="showUserProfile = false"/>

        <!-- Show Modal to update Sender's Profile -->
        <SenderProfileUpdate 
            :chatRoomID="chatRoom.chat_room_id"
            :isOpen="showProfileUpdateModal" 
            :senderProfile="userProfile" 
            @handleprofileUpdate="updateSenderProfile"
        />
        <!-- Show Modal to update Sender's Profile -->
    </div>
</template>

<script>
import { mapState } from 'vuex'

import MembersListings from './Members/MembersListings.vue'
import MemberOneToOneChat from './Members/MemberOneToOneChat.vue'
import UserProfileDrawer from './Presentational/UserProfileDrawer.vue'
import SenderProfileUpdate from './Presentational/SenderProfileUpdate.vue'

export default {
    name: 'ChatDrawer',
    props: {
        showDrawer: {
            type: Boolean,
            default: false,
        },
        consumer: {
            type: Object,
            default: false,
        },
        chatRoom: {
            type: Object,
            default: false,
        },
        userProfile: {
            type: Object,
            default: false,
        },
        selectedMemberForChat: {
            type: Object,
            default: false,
        },
        roomMembers : {
            type: Array,
            default: []
        },
        chatRoomChatHistory: {
            type: Array,
            default: []
        },
        unreadMessageCount : {
            type: Number,
            default: 0
        }
    },
    components: {
        MembersListings,
        MemberOneToOneChat,
        UserProfileDrawer,
        SenderProfileUpdate  
    },
    computed: {
        ...mapState({
            profile: (state) => state.consumer.profile,
        })
        
    },
    data() {
        return {
            activeComponent: 'MembersListings',
            activeTab: 'member_participants',
            activeListType:'list',
            showUserProfile:false,
            selectedProfileToView:null,
            showProfileUpdateModal:false,
        }
    },
    methods :{
        switchTabView(value){
            this.activeTab = value
        },
        switchComponent(value){
            this.activeComponent = value
        },
        toggleUserProfile(selectedProfile) {
            this.selectedProfileToView = selectedProfile
            this.showUserProfile = true
        },
        handleChatSelection(selectedChatMember) {
            this.$emit('handleChatSelection', selectedChatMember)
            this.activeComponent = 'MemberOneToOneChat'
        },
        handleBackClick() {
            this.selectedMemberForChat = null
            this.activeComponent = 'MembersListings'
        },
        selectForChat() {
            this.handleChatSelection(this.selectedProfileToView)
            this.selectedProfileToView = null
            this.showUserProfile = false
        },
        handleProfileUpdate() {
            this.$emit('closeDrawer')
            this.showProfileUpdateModal = true
        },
        updateSenderProfile(){
            this.showProfileUpdateModal = false
            this.$emit('openDrawer')
        }
    }      
}
</script>
